import { Permission } from './../permissions/permission';

export class Role {
    Id: string;
    Name: string;
    Description: string;

    Permissions: Permission[];
    IsAllPermissionsChecked: boolean;

    RoleId: string;
}


// WEBPACK FOOTER //
// ./src/app/main/models/roles/role.ts